// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__10NKA","fadeIn":"loader_fadeIn__3Nmsi"};